import { formatPrice } from '@dashboard/services/formatting';

export const getCouponDurationLabel = ({ duration, durationInMonths }) => {
  switch (duration) {
    case 'forever':
      return 'Every payment';
    case 'once':
      return 'First payment';
    case 'repeating':
      return `Multiple payments (${durationInMonths} months)`;
    default:
      return '';
  }
};

export const COUPON_DURATION_LABEL = 'On subscriptions, discount';

export const COUPON_DURATION_OPTIONS = [
  { value: 'forever', label: 'Every payment' },
  { value: 'once', label: 'First payment only' },
  { value: 'repeating', label: 'For a set number of months' },
];

// The duration in the create form's own words, with the months filled in.
export const getCouponDurationOptionLabel = ({ duration, durationInMonths }) => {
  if (duration !== 'repeating') {
    return COUPON_DURATION_OPTIONS.find(option => option.value === duration)?.label;
  }
  return `For ${durationInMonths} ${Number(durationInMonths) === 1 ? 'month' : 'months'}`;
};

// `amountOff` is in minor units, as stored on the coupon.
export const getCouponDiscountLabel = ({ percentOff, amountOff, currency, ...coupon }) => {
  const duration = getCouponDurationLabel(coupon).toLocaleLowerCase();

  if (percentOff) return `${percentOff}% off ${duration}`;
  if (amountOff) return `${formatPrice({ amount: amountOff, currency })} off ${duration}`;
  return '';
};
